import { useMutation, useQueryClient } from "@tanstack/react-query";
import { httpRequest } from "@/lib/axios";
import { CreateStageRequestDTO, UpdateStageRequestDTO, StageResponse } from "@/types";

async function createStage(
  request: CreateStageRequestDTO
): Promise<StageResponse> {
  const response = await httpRequest.post<StageResponse>(
    "/clinic/crm/stages",
    request
  );
  return response.data;
}

export function useCreateStageMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createStage,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["stages"] });
      queryClient.invalidateQueries({ queryKey: ["stages", "list"] });
    },
  });
}

async function updateStage(
  id: string,
  request: UpdateStageRequestDTO
): Promise<StageResponse> {
  const response = await httpRequest.put<StageResponse>(
    `/clinic/crm/stages/${id}`,
    request
  );
  return response.data;
}

export function useUpdateStageMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: UpdateStageRequestDTO }) =>
      updateStage(id, data),
    onSuccess: (_, { id }) => {
      queryClient.invalidateQueries({ queryKey: ["stages"] });
      queryClient.invalidateQueries({ queryKey: ["stages", "list"] });
      queryClient.invalidateQueries({ queryKey: ["stages", id] });
    },
  });
}

async function deleteStage(id: string): Promise<void> {
  await httpRequest.delete(`/clinic/crm/stages/${id}`);
}

export function useDeleteStageMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteStage,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["stages"] });
      queryClient.invalidateQueries({ queryKey: ["stages", "list"] });
    },
  });
}